import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface CurrencyData {
    currency: string;
    endBalance: number;
    fees: number;
    capitalPL: number;
    income: number;
    totalPL: number;
}

interface CurrencyTableProps {
    data: CurrencyData[];
}

const CurrencyTable: React.FC<CurrencyTableProps> = ({ data }) => {
    const { t } = useTranslation();

    return (
        <Paper elevation={0} sx={{
            p: 2,
            bgcolor: (theme) => theme.palette.background.paper,
            borderRadius: 1,
            border: '1px solid',
            borderColor: 'divider',
            mt: 3,
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        }}>
            <TableContainer>
                <Table sx={{ minWidth: '100%' }}>
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('taxReports.table.currency')}</TableCell>
                            <TableCell align="right">{t('taxReports.table.endBalance')}</TableCell>
                            <TableCell align="right">{t('taxReports.table.fees')}</TableCell>
                            <TableCell align="right">{t('taxReports.table.capitalPL')}</TableCell>
                            <TableCell align="right">{t('taxReports.table.income')}</TableCell>
                            <TableCell align="right">{t('taxReports.table.totalPL')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row) => (
                            <TableRow key={row.currency}>
                                <TableCell component="th" scope="row">
                                    {row.currency}
                                </TableCell>
                                <TableCell align="right">{row.endBalance}</TableCell>
                                <TableCell align="right">{row.fees}</TableCell>
                                <TableCell align="right">{row.capitalPL}</TableCell>
                                <TableCell align="right">{row.income}</TableCell>
                                <TableCell align="right">{row.totalPL}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default CurrencyTable;
